<nav class="stepper" aria-label="Progress">
  <ol class="stepper__list">
    @for (step of steps; track step.number; let last = $last) {
      <li class="stepper__item"
          [class.stepper__item--active]="step.number === currentStep"
          [class.stepper__item--complete]="step.number < currentStep">
        <div class="stepper__circle"
             [class.stepper__circle--active]="step.number === currentStep"
             [class.stepper__circle--complete]="step.number < currentStep">
          @if (step.number < currentStep) {
            <ngk-icon icon="check" size="1rem" />
          } @else {
            {{ step.number }}
          }
        </div>
        <span class="stepper__label"
              [class.stepper__label--active]="step.number === currentStep">
          {{ step.label }}
        </span>
      </li>
      @if (!last) {
        <li class="stepper__connector"
            [class.stepper__connector--complete]="step.number < currentStep">
        </li>
      }
    }
  </ol>
</nav>
